import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e2e6ff4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "student-dashboard grid grid-cols-1 xl:grid-cols-2" }
const _hoisted_2 = { class: "bg-student-gradient-t-b text-white p-9 flex flex-col border-b xl:border-b-0 xl:border-r border-green-1" }
const _hoisted_3 = { class: "flex justify-center m-5 lg:m-20 lg:w-86 lg:h-86" }
const _hoisted_4 = { class: "xl:flex items-start lg:pl-16 lg:pr-16 flex-col" }
const _hoisted_5 = { class: "flex-1 mb-4 text-display-xs" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Auf dieser Seite findest du die neuesten Stellenausschreibungen, neue Challenges | Mentorings sowie den aktuellen Stand deiner Matches. Damit du keinen Match verpasst, behalten wir dich auch per E-Mail up-to-date. ", -1))
const _hoisted_7 = { class: "flex-1 mt-8 mb-4 text-display-xs" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-8" }, " Damit dich Companies & Unis besser finden können, solltest du zuerst dein Profil vervollständigen. ", -1))
const _hoisted_9 = { class: "flex flex-col min-h-full" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-base font-medium text-primary-1 mb-4" }, "Stellen", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-base font-medium text-primary-1 mb-4 mt-12" }, "Challenges | Mentorings", -1))
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-base font-medium text-primary-1 mb-4" }, "Challenges | Mentorings", -1))
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-base font-medium text-primary-1 mb-4" }, "Stellen", -1))

import type { Dashboard } from "@/api/models/types";
import { AttachmentKey } from "@/api/models/types";
import MatchdButton from "@/components/MatchdButton.vue";
import ProfileSection from "@/components/ProfileSection.vue";
import PostingDetailLink from "@/components/dashboard/PostingDetailLink.vue";
import PostingEditLink from "@/components/dashboard/PostingEditLink.vue";
import useProgressIndicator from "@/helpers/useProgressIndicator";
import { Routes } from "@/router";
import { useStore } from "@/store";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import ChallengeTypeMentoringButton from "../ChallengeTypeMentoringButton.vue";
import StackImage from "../StackImage.vue";
import DeletionInfoModal from "./DeletionInfoModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentDashboard',
  props: {
    dashboard: {}
  },
  setup(__props: any) {



const store = useStore();
const route = useRoute();
const showDeletionInfoModal = ref(false);
const { formatProgress, studentProgress } = useProgressIndicator();

const user = computed(() => store.getters["user"]);

const avatar = computed(
  () =>
    store.getters["attachmentsByKey"]({
      key: AttachmentKey.StudentAvatar,
    })?.[0] ||
    store.getters["attachmentsByKey"]({
      key: AttachmentKey.StudentAvatarFallback,
    })?.[0] ||
    undefined
);

onMounted(() => {
  if ("challengeDeleted" in route.query) {
    showDeletionInfoModal.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (avatar.value)
          ? (_openBlock(), _createBlock(StackImage, {
              key: 0,
              class: "avatar rounded-full object-cover",
              url: avatar.value.url,
              stack: "avatar",
              alt: `${user.value?.firstName} Profilbild`
            }, null, 8, ["url", "alt"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, "Hey " + _toDisplayString(user.value?.firstName) + ", ready to match?", 1),
        _hoisted_6,
        (_unref(studentProgress) && _unref(studentProgress).global < 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h2", _hoisted_7, " Dein Profil ist zu " + _toDisplayString(_unref(formatProgress)(_unref(studentProgress).global)) + " vollständig. ", 1),
              _hoisted_8,
              _createVNode(MatchdButton, {
                tag: "router-link",
                to: { name: _unref(Routes).PROFILE_EDIT, params: { step: 'schritt1' } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Profil vervollständigen ")
                ]),
                _: 1
              }, 8, ["to"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.dashboard.latestJobPostings?.length || _ctx.dashboard.latestChallenges?.length)
        ? (_openBlock(), _createBlock(ProfileSection, {
            key: 0,
            title: "Neue Stellen und Challenges | Mentorings"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              (_ctx.dashboard.latestJobPostings?.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Momentan sind keine zu dir passenden Stellen ausgeschrieben. "))
                : _createCommentVNode("", true),
              (_ctx.dashboard.latestJobPostings?.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.latestJobPostings, (jobPosting) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: jobPosting.id,
                          class: "link-list__item"
                        }, [
                          _createVNode(PostingDetailLink, { posting: jobPosting }, null, 8, ["posting"])
                        ]))
                      }), 128))
                    ]),
                    _createVNode(MatchdButton, {
                      class: "block w-full mt-8 text-center",
                      to: { name: _unref(Routes).JOB_POSTING_SEARCH },
                      tag: "router-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Weitere Stellen finden ")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_12,
              (_ctx.dashboard.latestChallenges?.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Momentan sind keine zu dir passenden Challenges | Mentorings ausgeschrieben. "))
                : _createCommentVNode("", true),
              (_ctx.dashboard.latestChallenges?.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.latestChallenges, (challenge) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: challenge.id,
                        class: "link-list__item"
                      }, [
                        _createVNode(PostingDetailLink, { posting: challenge }, null, 8, ["posting"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(MatchdButton, {
                class: "block w-full mt-8 text-center",
                to: { name: _unref(Routes).CHALLENGE_CREATE },
                tag: "router-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Challenge | Mentoring ausschreiben ")
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(ChallengeTypeMentoringButton)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.dashboard.challenges?.length)
        ? (_openBlock(), _createBlock(ProfileSection, {
            key: 1,
            title: "Deine Challenge-Ideen"
          }, {
            default: _withCtx(() => [
              (_ctx.dashboard.challenges?.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Momentan sind keine zu dir passenden Challenges | Mentorings ausgeschrieben. "))
                : _createCommentVNode("", true),
              (_ctx.dashboard.challenges?.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.challenges, (challenge) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: challenge.id,
                        class: "link-list__item"
                      }, [
                        _createVNode(PostingEditLink, {
                          type: "challenge",
                          posting: challenge
                        }, null, 8, ["posting"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(ProfileSection, { title: "Deine offenen Matches" }, {
        default: _withCtx(() => [
          (_ctx.dashboard.requestedMatches && _ctx.dashboard.requestedMatches?.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Sobald deine Matching-Anfrage vom Unternehmen bestätigt wurde, kanns mit dem Kennenlernen weitergehen. "))
            : _createCommentVNode("", true),
          (_ctx.dashboard.requestedMatches?.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Momentan hast du keine offenen Matches. Sobald du ein Match auslöst, wirst du das hier sehen. "))
            : _createCommentVNode("", true),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.requestedMatches, (match) => {
              return (_openBlock(), _createElementBlock("li", {
                key: match.id,
                class: "link-list__item mt-4"
              }, [
                _createVNode(PostingDetailLink, {
                  posting: match.jobPosting
                }, null, 8, ["posting"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(ProfileSection, { title: "Anfragen zum Matching" }, {
        default: _withCtx(() => [
          (_ctx.dashboard.unconfirmedMatches?.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Dein Talent ist gesucht! Folgende Unternehmen möchten dich gerne kennenlernen. "))
            : (_openBlock(), _createElementBlock("p", _hoisted_20, " Momentan hast du keine offenen Anfragen. Sobald ein Unternehmen dich matchen möchte, siehst du das hier. ")),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.unconfirmedMatches, (match) => {
              return (_openBlock(), _createElementBlock("li", {
                key: match.jobPosting.id,
                class: "link-list__item mt-4"
              }, [
                _createVNode(PostingDetailLink, {
                  posting: match.jobPosting
                }, null, 8, ["posting"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      (_ctx.dashboard.confirmedMatches?.length || _ctx.dashboard.challengeMatches?.length)
        ? (_openBlock(), _createBlock(ProfileSection, {
            key: 2,
            title: "Hier hats gematchd!"
          }, {
            default: _withCtx(() => [
              (_ctx.dashboard.challengeMatches?.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_21,
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.challengeMatches, (match) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: match.challenge.id,
                          class: "link-list__item"
                        }, [
                          _createVNode(PostingDetailLink, {
                            posting: match.challenge,
                            matcher: match.company
                          }, null, 8, ["posting", "matcher"])
                        ]))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.dashboard.confirmedMatches?.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                    _hoisted_23,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.confirmedMatches, (match) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: match.jobPosting.id,
                        class: "link-list__item"
                      }, [
                        _createVNode(PostingDetailLink, {
                          posting: match.jobPosting,
                          type: "job"
                        }, null, 8, ["posting"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(DeletionInfoModal, {
      showModal: showDeletionInfoModal.value,
      "onUpdate:showModal": _cache[0] || (_cache[0] = ($event: any) => ((showDeletionInfoModal).value = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode("Challenge | Mentoring gelöscht")
      ]),
      default: _withCtx(() => [
        _createTextVNode(" Die Challenge | Mentoring wurde erfolgreich gelöscht. ")
      ]),
      _: 1
    }, 8, ["showModal"])
  ]))
}
}

})